// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xmfobwtdgbqcaorfcffi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhtZm9id3RkZ2JxY2FvcmZjZmZpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY4ODczODksImV4cCI6MjA1MjQ2MzM4OX0.1c4VfH4nOnvEwixPUGGhz-skesHJz8j1ZaAG1ipkm8s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);